const MyOrdersAdvisorCellTypes = {
    "completed": "completed",
    "need-review": "need-review"
};
var my_orders_advisor_cell_types = Object.freeze(MyOrdersAdvisorCellTypes);

export { my_orders_advisor_cell_types as default };
//# sourceMappingURL=my_orders_advisor_cell_types.js.map
